import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Grid, GridItem, Message } from '@bwoty-web/ui-kit';
import Filters from './src/components/Filters';
import TableHeadings from './src/components/TableHeadings';
import FixtureList from './src/components/FixtureList';
import ErrorBoundary from './src/components/ErrorBoundary';
import * as S from './style';

const FootballFixtures = ({
  siteSettings = {},
  attributeCollection: labels = {},
  fixtures = [],
}) => {
  const { team } = siteSettings;
  const { tableLayout, teams } = labels;
  const [viewSettings, setViewSettings] = useState({
    searchOpponent: '',
    hideSoldout: false,
    hidePast: true,
    sortBy: { column: 'matchDate', order: 'asc' },
  });

  const handleViewSettings = (state) => {
    setViewSettings(state);
  };

  return (
    <React.StrictMode>
      <S.FootballFixtures>
        {teams?.[team]?.showSalesInfo && (
          <Message
            header={teams?.[team]?.salesInfoHeading || 'teams.team.salesInfoHeading'}
            messageType="info"
            expandable
            style={{ marginBottom: 'var(--space-grid-row-gap)' }}
          >
            {teams?.[team]?.salesInfoMore}
          </Message>
        )}
        <ErrorBoundary tableLayout={tableLayout}>
          {teams?.[team]?.inSale && (
            <Grid>
              <GridItem columnSpan={3}>
                <Filters
                  tableLayout={tableLayout}
                  viewSettings={viewSettings}
                  handleViewSettings={handleViewSettings}
                />
              </GridItem>
              <GridItem columnSpan={9}>
                <S.FixtureTable>
                  <thead>
                    <TableHeadings
                      labels={labels}
                      viewSettings={viewSettings}
                      team={team}
                      handleViewSettings={handleViewSettings}
                    />
                  </thead>
                  <tbody>
                    <FixtureList
                      fixtures={fixtures}
                      labels={labels}
                      siteSettings={siteSettings}
                      viewSettings={viewSettings}
                    />
                  </tbody>
                </S.FixtureTable>
              </GridItem>
            </Grid>
          )}
        </ErrorBoundary>
        {!teams && (
          <Message header="Error fetching attribute collection" messageType="error" expandable>
            {'Please refresh page or contact support if the problem persists.'}
          </Message>
        )}
      </S.FootballFixtures>
    </React.StrictMode>
  );
};

FootballFixtures.propTypes = {
  siteSettings: PropTypes.shape({
    baseUrl: PropTypes.string,
    env: PropTypes.string,
    hotelListPageUrl: PropTypes.string,
    siteId: PropTypes.number,
    imageUrl: PropTypes.string,
    team: PropTypes.string,
  }).isRequired,
  attributeCollection: PropTypes.shape({
    bookingTexts: PropTypes.shape(),
    tableLayout: PropTypes.shape(),
    teams: PropTypes.shape({
      salesInfoHeading: PropTypes.string,
    }),
  }).isRequired,
  fixtures: PropTypes.arrayOf(PropTypes.shape()).isRequired,
};

export default FootballFixtures;
